/* ==========================================================================
   Empire Relic — product.js
   Variant picker, media gallery + zoom, quantity, sticky mobile bar.
   ========================================================================== */
(function () {
  'use strict';

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  var productSection = qs('[data-product-section]');
  if (!productSection) return;

  var dataEl = qs('[data-product-json]', productSection);
  var product = dataEl ? JSON.parse(dataEl.textContent) : null;
  var moneyFormat = productSection.getAttribute('data-money-format') || '£{{amount}}';

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, amount);
  }

  /* ---------- Variant selection ---------- */
  var optionInputs = qsa('[data-option-input]', productSection);
  var idInput = qs('[data-variant-id]', productSection);
  var priceEl = qs('[data-product-price]', productSection);
  var comparePriceEl = qs('[data-product-compare-price]', productSection);
  var badgeEl = qs('[data-product-sale-badge]', productSection);
  var atcButton = qs('[data-add-to-cart]', productSection);
  var atcText = qs('[data-add-to-cart-text]', productSection);
  var buyButtons = qs('[data-payment-button]', productSection);
  var stickyPrice = qs('[data-sticky-price]');
  var digitalNote = qs('[data-digital-note]', productSection);
  var physicalNote = qs('[data-physical-note]', productSection);

  function selectedOptions() {
    var options = [];
    qsa('[data-option-index]', productSection).forEach(function (group) {
      var checked = qs('input:checked', group);
      var select = qs('select', group);
      if (checked) options.push(checked.value);
      else if (select) options.push(select.value);
    });
    return options;
  }

  function findVariant(options) {
    if (!product) return null;
    return product.variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === options[i]; });
    }) || null;
  }

  /* Keep dependent option groups compatible. Selecting a physical format
     automatically moves Size away from “Digital download”, while choosing
     Digital File restores the digital size and disables impossible choices. */
  function syncDependentOptions(changedIndex) {
    if (!product) return;
    var groups = qsa('[data-option-index]', productSection);
    for (var i = Math.max(0, changedIndex + 1); i < groups.length; i++) {
      var prefix = [];
      for (var j = 0; j < i; j++) {
        var earlier = qs('input:checked', groups[j]);
        var earlierSelect = qs('select', groups[j]);
        prefix.push(earlier ? earlier.value : (earlierSelect ? earlierSelect.value : ''));
      }
      var validValues = product.variants.filter(function (variant) {
        return variant.available && prefix.every(function (value, index) {
          return variant.options[index] === value;
        });
      }).map(function (variant) { return variant.options[i]; });

      var inputs = qsa('input[data-option-input]', groups[i]);
      inputs.forEach(function (candidate) {
        candidate.disabled = validValues.indexOf(candidate.value) === -1;
      });

      var selected = qs('input:checked', groups[i]);
      if (inputs.length && (!selected || selected.disabled)) {
        var replacement = inputs.find(function (candidate) { return !candidate.disabled; });
        if (replacement) {
          replacement.checked = true;
          var selectedLabel = qs('[data-selected-value]', groups[i]);
          if (selectedLabel) selectedLabel.textContent = replacement.value;
        }
      }
    }
  }

  /* Digital-vs-physical notices are driven by the selected FORMAT option
     (option 1), so they update correctly even for an incomplete/invalid
     Format + Size combination. */
  function updateFormatNotes() {
    var firstGroup = qs('[data-option-index="0"]', productSection);
    var checked = firstGroup ? qs('input:checked', firstGroup) : null;
    var select = firstGroup ? qs('select', firstGroup) : null;
    var value = checked ? checked.value : (select ? select.value : '');
    var isDigital = /digital/i.test(value);
    if (digitalNote) digitalNote.toggleAttribute('hidden', !isDigital);
    if (physicalNote) physicalNote.toggleAttribute('hidden', isDigital);
  }

  function updateUI(variant) {
    if (!variant) {
      if (atcButton) {
        atcButton.setAttribute('disabled', '');
        if (atcText) atcText.textContent = window.variantStrings.unavailable;
      }
      return;
    }

    if (idInput) idInput.value = variant.id;

    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    if (comparePriceEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        comparePriceEl.textContent = formatMoney(variant.compare_at_price);
        comparePriceEl.removeAttribute('hidden');
        if (badgeEl) {
          var pct = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
          badgeEl.textContent = badgeEl.getAttribute('data-save-label').replace('[percent]', pct);
          badgeEl.removeAttribute('hidden');
        }
      } else {
        comparePriceEl.setAttribute('hidden', '');
        if (badgeEl) badgeEl.setAttribute('hidden', '');
      }
    }
    if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);

    if (atcButton) {
      if (variant.available) {
        atcButton.removeAttribute('disabled');
        if (atcText) atcText.textContent = window.variantStrings.addToCart;
      } else {
        atcButton.setAttribute('disabled', '');
        if (atcText) atcText.textContent = window.variantStrings.soldOut;
      }
    }
    if (buyButtons) buyButtons.classList.toggle('hidden', !variant.available);

    if (variant.featured_media && variant.featured_media.id) {
      var mediaBtn = qs('[data-thumb][data-media-id="' + variant.featured_media.id + '"]', productSection);
      if (mediaBtn) mediaBtn.click();
    }

    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  }

  optionInputs.forEach(function (input) {
    input.addEventListener('change', function () {
      var group = input.closest('[data-option-index]');
      var valueLabel = qs('[data-selected-value]', group);
      if (valueLabel) valueLabel.textContent = input.value;
      var changedIndex = parseInt(group.getAttribute('data-option-index'), 10);
      syncDependentOptions(isNaN(changedIndex) ? -1 : changedIndex);
      updateUI(findVariant(selectedOptions()));
      updateFormatNotes();
    });
  });

  /* Set compatible options and the correct notice on first load. */
  syncDependentOptions(-1);
  updateUI(findVariant(selectedOptions()));
  updateFormatNotes();

  /* ---------- Media gallery ---------- */
  var mainWrap = qs('[data-main-media]', productSection);
  var mainImg = mainWrap ? qs('img', mainWrap) : null;

  qsa('[data-thumb]', productSection).forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (!mainImg) return;
      mainImg.src = thumb.getAttribute('data-src');
      mainImg.srcset = thumb.getAttribute('data-srcset') || '';
      mainImg.alt = thumb.getAttribute('data-alt') || '';
      qsa('[data-thumb]', productSection).forEach(function (t) { t.setAttribute('aria-current', 'false'); });
      thumb.setAttribute('aria-current', 'true');
      mainWrap.classList.remove('is-zoomed');
    });
  });

  /* ---------- Zoom ---------- */
  if (mainWrap && mainImg) {
    mainWrap.addEventListener('click', function (e) {
      var rect = mainWrap.getBoundingClientRect();
      mainWrap.style.setProperty('--zoom-x', ((e.clientX - rect.left) / rect.width * 100) + '%');
      mainWrap.style.setProperty('--zoom-y', ((e.clientY - rect.top) / rect.height * 100) + '%');
      mainWrap.classList.toggle('is-zoomed');
    });
    mainWrap.addEventListener('mousemove', function (e) {
      if (!mainWrap.classList.contains('is-zoomed')) return;
      var rect = mainWrap.getBoundingClientRect();
      mainWrap.style.setProperty('--zoom-x', ((e.clientX - rect.left) / rect.width * 100) + '%');
      mainWrap.style.setProperty('--zoom-y', ((e.clientY - rect.top) / rect.height * 100) + '%');
    });
    mainWrap.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); mainWrap.classList.toggle('is-zoomed'); }
    });
  }

  /* ---------- Quantity ---------- */
  var qtyInput = qs('[data-product-quantity]', productSection);
  qsa('[data-product-quantity-change]', productSection).forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!qtyInput) return;
      var delta = parseInt(btn.getAttribute('data-product-quantity-change'), 10);
      qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + delta);
    });
  });

  /* ---------- Sticky mobile bar ---------- */
  var stickyBar = qs('[data-sticky-bar]');
  var buyBlock = qs('[data-buy-block]', productSection);
  if (stickyBar && buyBlock && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      stickyBar.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
    }, { threshold: 0 });
    observer.observe(buyBlock);
    var stickyBtn = qs('[data-sticky-add]', stickyBar);
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var y = buyBlock.getBoundingClientRect().top + window.scrollY - 90;
        window.scrollTo({ top: y, behavior: 'smooth' });
      });
    }
  }
})();
